
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";

const orderModule = getModule(OrderModule);

@Component
export default class OrderNotes extends Vue {
  @Prop({ default: false })
  public loading: boolean;

  @Prop({ default: () => null })
  public order: Object;

  @Prop({default: false})
  public displayShipWithOrderCheckbox: boolean;

  get notes() {
    return orderModule.currentOrderNotes;
  }

  mounted() {
    orderModule.getOrderNotes(this.order);
  }

  getNoteVisibility(note) {
    if (note.customerViewable & note.facilityViewable) return "ALL";
    if (note.facilityViewable) return "Network Member";
    if (note.customerViewable) return "Customer";
    return "CDS Only";
  }

  deleteNote(note) {
    this.$bvModal
      .msgBoxConfirm("Are you sure you want to delete this note? This action cannot be undone.")
      .then(confirmed => {
        if (confirmed) {
          orderModule
            .deleteOrderNote({
              orderId: orderModule.currentOrder.number,
              id: note.id,
              isLegacy: note.isLegacy
            })
            .then(response => console.log(response))
            .catch(ex => console.error(ex));
        }
      });
  }

  addOrderNote() {
    orderModule.showAddNoteModal({
      orderNumber: orderModule.currentOrder.number,
      displayShipWithOrderCheckbox: this.displayShipWithOrderCheckbox
    });
  }

  editOrderNote(note) {
    orderModule.editAddNoteModal(note);
  }
}
